import { useLocation, useNavigate } from "react-router-dom";
import { useScrollTo } from "./Reveal";

const Footer = () => {
  const scrollTo = useScrollTo();
  const location = useLocation();
  const navigate = useNavigate();
  const links = [
    { label: "Solutions", href: "#services" },
    { label: "Approach", href: "#approach" },
    { label: "Calculator", href: "#calculator" },
    { label: "About", href: "#about" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "#contact" },
  ];
  const company = [
    { label: "Our Story", href: "/about-us" },
    { label: "Brands", href: "/our-brands" },
    { label: "Careers", href: "/careers" },
    { label: "Schedule a Call", href: "/schedule-a-call" },
    { label: "FAQ", href: "/faq" },
    { label: "Terms & Conditions", href: "/terms-con." },
  ];
  const go = (href) => {
    if (href.startsWith("/")) { navigate(href); return; }
    if (location.pathname !== "/") { navigate("/" + href); return; }
    scrollTo(href);
  };
  return (
    <footer className="relative bg-white border-t border-ink/10" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <img src="/assets/skope-logo-full.png" alt="Skope Kitchens" className="h-8 w-auto" data-testid="footer-logo" />
            <p className="mt-6 font-display font-semibold text-xl lg:text-2xl text-ink tracking-tight">
              BUILDING ICONIC FOOD BRANDS PEOPLE LOVE.
            </p>
            <p className="mt-3 text-sm text-ink/45 max-w-sm leading-relaxed">
              From food concept to commercial kitchen to scalable operations.
            </p>
          </div>
          <div className="lg:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.3em] text-ink/35 uppercase">Navigate</div>
            <nav className="mt-5 flex flex-col gap-3" aria-label="Footer">
              {links.map((l) => (
                <button key={l.label} onClick={() => go(l.href)} className="text-left text-sm text-ink/60 hover:text-skope transition-colors w-fit" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.3em] text-ink/35 uppercase">Company</div>
            <nav className="mt-5 flex flex-col gap-3" aria-label="Company">
              {company.map((l) => (
                <button key={l.label} onClick={() => go(l.href)} className="text-left text-sm text-ink/60 hover:text-skope transition-colors w-fit" data-testid={`footer-link-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}>
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.3em] text-ink/35 uppercase">Reach Us</div>
            <div className="mt-5 flex flex-col gap-3">
              <a href="mailto:contact@skopekitchens.com" className="text-sm text-ink/60 hover:text-skope transition-colors w-fit" data-testid="footer-email">contact@skopekitchens.com</a>
              <a href="tel:+918618689724" className="text-sm text-ink/60 hover:text-skope transition-colors w-fit" data-testid="footer-phone">+91 8618689724</a>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-ink/5 flex flex-col sm:flex-row justify-between gap-4">
          <span className="font-mono text-[10px] tracking-[0.2em] text-ink/30 uppercase">© 2026 Skope Kitchens. All rights reserved.</span>
          <span className="font-mono text-[10px] tracking-[0.2em] text-ink/30 uppercase">Food · Design · Operations · Scale</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
